// extracted by mini-css-extract-plugin
module.exports = {"hoverItem":"hoveritem_hoverItem__1ixbS"};